{
  "list": {
    "content": {
      "orderService": "Service",
      "id": "ID",
      "guaranteeNumber": "Guarantee number",
      "status": "Status",
      "type": "Type",
      "beneficiaryName": "Beneficiary",
      "currency": "Currency",
      "guaranteeCurrencyName": "Currency",
      "guaranteeAmount": "Amount",
      "effectiveDate": "Issuance date",
      "expirationDate": "Expiration date",
      "formTemplateName": "Guarantee type",
      "enFormTemplateName": "Guarantee type",
      "lastModifiedDate": "Modification date",
      "creditLineExceeded": "Credit line conditions exceeded",
      "childNumber": "Change No."
    },
    "buttons": {
      "new": "New order",
      "order": "Order preview",
      "copy": {
        "name": "Copy order",
        "tooltip": "Place a new order using the completed order as a template"
      }
    }
  },
  "details": {
    "basicInfo": {
      "client": "Client",
      "clientCis": "CIS",
      "guaranteeNumber": "Guarantee number",
      "guaranteeAccountNumber": "Guarantee account number",
      "id": "ID",
      "lastModifiedDate": "Last modification date",
      "operator": "Operator",
      "orderDetails": {
        "OWN": "Order details",
        "ANNEX": "Annex order details",
        "GUARANTEE_MODIFICATION": "Guarantee modification details",
        "modificationType": {
          "RELEASE_GUARANTEE": "Early release",
          "PARTIAL_RELEASE": "Partial release",
          "RECALCULATE_PAYMENT_SCHEDULE": "Schedule change"
        }
      },
      "annexNumber": "Annex number",
      "status": "Status",
      "type": "Type",
      "addressLabel": "Address",
      "address": {
        "zipCode": "Postal code",
        "city": "City",
        "voivodeship": "Voivodeship",
        "country": "Country",
        "line1": "Address line 1",
        "line2": "Address line 2",
        "line3": "Address line 3",
        "line4": "Address line 4"
      },
      "prevExpirationDate": "Original expiration date of the guarantee",
      "newExpirationDate": "New guarantee expiration date",
      "modificationNumber": "Modification number",
      "prevGuaranteeAmount": "Previous guarantee amount",
      "newGuaranteeAmount": "New guarantee amount",
      "scheduleChangedDate": "Schedule change date"
    },
    "content": {
      "safeguard": "Guarantee under",
      "creditLineId": "Credit line",
      "address": "Address",
      "beneficiaryAddrAdditionalLine": "Address line",
      "guaranteeAmount": "Amount",
      "amountAfterReduction": "Reduced amount",
      "guaranteeAmountWords": "Amount in words",
      "bankName": "Bank",
      "bankAddress": "Bank address",
      "beneficiary": "Beneficiary",
      "beneficiaryAddrCity": "City",
      "beneficiaryAddrCountryCode": "Country",
      "guaranteeCurrencyItem": "Currency",
      "date": "Date",
      "reduction": "Reduction",
      "guaranteeData": "Guarantee data",
      "guaranteeForm": "Guarantee form",
      "formTemplateName": "Type",
      "customContent": "Custom content",
      "message": {
        "saveFailed": "Changes were not saved. The form contains errors.",
        "validationFailed": "Validation failed. Incorrect fields have been marked in the form.",
        "validationFailedOnView": "Validation failed. Please review and correct the data in edit mode.",
        "validationSuccess": "Validation was successful"
      },
      "beneficiaryName": "Name",
      "orderOrigin": "Order source",
      "reductionDueTo": "Reduction due to",
      "reductions": "Reductions",
      "guaranteeWithin": "Guarantee under",
      "contractNumber": "Contract number",
      "beneficiaryAddrStreet": "Street",
      "effectiveDateOwn": "Guarantee issuance date",
      "effectiveDateAnnex": "Annex issuance date",
      "effectiveDateGuarantee_modification": "Date of issue of the guarantee",
      "expirationDate": "Guarantee expiration date",
      "beneficiaryAddrVoivodeship": "Voivodeship",
      "beneficiaryAddrZipCode": "Postal code",
      "creditLineWarningModal": "The entered order parameters are inconsistent with the credit decision. Issuance of the guarantee requires the Bank’s approval."
    },
    "attachment": {
      "name": "Name",
      "createdDate": "Submission date",
      "createdBy": "User",
      "origin": "Submitting party",
      "guarantee": "Guarantee",
      "annex": "Annex",
      "other": "Other",
      "guarantees": "Guarantees",
      "others": "Other",
      "annexes": "Guarantee annexes",
      "deleteSuccess": "Document deleted",
      "modal": {
        "title": "Add attachment",
        "upload": "Upload file",
        "uploadSuccess": "Attachment upload successful",
        "deleteWarning": "Are you sure you want to delete the attachment? If there are previous versions, they will also be deleted."
      }
    },
    "childTab": {
      "buttons": {
        "preview": {
          "annex": "Annex preview",
          "modification": "Modification preview"
        }
      },
      "content": {
        "annexNumber": "Annex No.",
        "modificationNumber": "Modification No.",
        "id": "ID",
        "beneficiaryName": "Beneficiary",
        "guaranteeAmount": "Amount",
        "formTemplateName": "Type",
        "status": "Status",
        "effectiveDate": "Date of issue",
        "expirationDate": "Expiration date",
        "lastModifiedDate": "Date of modification",
        "operatorName": "Operator"
      }
    },
    "chatTab": {
      "noMessages": "No comments",
      "send": "Send"
    },
    "nav": {
      "formTab": "Form",
      "annexFormTab": "Annex order",
      "modificationFormTab": "Guarantee modification",
      "attachments": "Attachments",
      "payments": "Payments",
      "annexes": "Annexes",
      "modifications": "Guarantee modifications",
      "projectsAndSignatures": "Projects and signatures",
      "chatTab": "Comments"
    },
    "buttons": {
      "action": {
        "name": "Order actions",
        "items": {
          "DELETE": "Delete",
          "CANCEL": "Cancel",
          "VERIFY": "Send for verification",
          "SIGNING": "Send for signing",
          "SIGN": "Sign",
          "READY_TO_COMPLETE": "Forward for execution",
          "RETURN_TO_DRAFT": "Withdraw for editing",
          "ANNEX": "Annex"
        }
      },
      "copy": {
        "name": "Copy order",
        "tooltip": "Place a new order using the completed order as a template"
      },
      "generateDocuments": {
        "name": "Document generation",
        "items": {
          "ORDER_OWN": "Guarantee order",
          "ORDER_ANNEX": "Annex order",
          "GUARANTEE_PROJECT": "Guarantee draft",
          "GUARANTEE_PROJECT_ADD": "Add the draft to your order",
          "ANNEX_PROJECT": "Annex draft",
          "ANNEX_PROJECT_ADD": "Add the draft to your order"
        }
      }
    },
    "updateStatusModal": {
      "guarantee": {
        "CANCEL": {
          "title": "Order cancellation",
          "text": "You are going to cancel the order. A service fee will be charged. Do you want to continue?"
        },
        "VERIFY": {
          "title": "Submit for verification",
          "text": "You are going to send an order for verification to the Bank. Do you want to continue?"
        },
        "SIGNING": {
          "title": "Submit for signature",
          "text": "You are going to send an order for signing. Do you want to continue?"
        },
        "READY_TO_COMPLETE": {
          "title": "Submit for implementation",
          "text": "You are going to send an order for execution at the Bank. Do you want to continue?"
        },
        "RETURN_TO_DRAFT": {
          "title": "Withdraw for editing",
          "text": "You are going to withdraw the order for editing. Do you want to continue?"
        }
      },
      "annex": {
        "CANCEL": {
          "title": "Cancellation of the annex order",
          "text": "You are going to cancel the annex order. A service fee will be charged. Do you want to continue?"
        },
        "VERIFY": {
          "title": "Submit for verification",
          "text": "You are going to send an annex order to the Bank for verification. Do you want to continue?"
        },
        "SIGNING": {
          "title": "Submit for signature",
          "text": "You are going to send an annex order for signing. Do you want to continue?"
        },
        "READY_TO_COMPLETE": {
          "title": "Submit for implementation",
          "text": "You are going to send an annex order to the Bank for execution. Do you want to continue?"
        },
        "RETURN_TO_DRAFT": {
          "title": "Withdraw for editing",
          "text": "You are going to withdraw the editing annex order. Do you want to continue?"
        }
      },
      "reason": "Cause (optional)",
      "guaranteeConfirmSaveModal": "Changes made on the order will be saved. Do you want to continue?",
      "annexConfirmSaveModal": "Changes made to the annex order will be saved. Do you want to continue?"
    },
    "deleteModal": {
      "title": "Delete order",
      "text": "The order will be deleted permanently. Do you want to continue?",
      "deleteSuccessText": "The order has been deleted"
    },
    "signOrderModal": {
      "guarantee": {
        "title": "Sign order",
        "text": "You are about to sign the order. If the signature scheme is met, the order will be forwarded for execution at the bank. Do you want to continue?"
      },
      "annex": {
        "title": "Sign annex order",
        "text": "You are about to sign the annex order. If the signature scheme is met, the annex order will be forwarded for execution at the bank. Do you want to continue?"
      },
      "signingSuccess": "The order has been signed.",
      "signingSuccessAndOrderStatusChanged": "The order has been signed and then forwarded for execution at the bank."
    },
    "paymentsTab": {
      "name": "Name",
      "enName": "Name",
      "newBaseAmount": "Base amount",
      "newBaseAmountAndCurrency": "Base amount and currency",
      "paymentCurrency": "Base currency",
      "amount": "Amount after conversion",
      "accountCurrency": "Currency",
      "account": "Debit account",
      "paymentDate": "Withdrawal date"
    },
    "projectsAndSignaturesTab": {
      "projects": {
        "sectionLabel": "Projects",
        "currentVersion": "Current project version",
        "previousVersions": "Previous versions",
        "modal": {
          "title": {
            "OWN": "Add guarantee project",
            "ANNEX": "Add annex project"
          },
          "uploadSuccess": "Project upload completed successfully"
        },
        "content": {
          "attachmentVersion": "Version No.",
          "bankApproved": "Bank approval",
          "clientApproved": "Client approval",
          "confirmationInfoMessage": "Confirmed on {{date}} by {{userName}}",
          "creator": "Sending party"
        },
        "warnings": {
          "acceptProject": {
            "OWN": "You are going to accept the draft guarantee. Do you want to continue?",
            "ANNEX": "You are going to accept the draft annex. Do you want to continue?"
          },
          "withdrawProjectAcceptance": {
            "OWN": "You are going to revoke approval of the draft guarantee. Do you want to continue?",
            "ANNEX": "You are going to revoke approval of the draft annex. Do you want to continue?"
          },
          "uploadProject": {
            "OWN": "You are going to attach a draft guarantee. The draft will automatically be marked as accepted. Do you want to continue?",
            "ANNEX": "You are going to attach a draft annex. The draft will automatically be marked as accepted. Do you want to continue?"
          }
        }
      },
      "signs": {
        "sectionLabel": "Signatures",
        "schemaFulfilled": "The scheme has been fulfilled",
        "schemaNotFulfilled": "The scheme has not been fulfilled",
        "schema": {
          "fulfilledDate": "Date and time",
          "fulfilledSchema": "Scheme",
          "orderSigns": "Submitted signatures"
        }
      }
    },

    "previousValuesModal": {
      "text": "<strong> The values in the following form fields have changed:</strong> <br> {{labels}}"
    }
  },
  "previousValueTooltip": {
    "empty": "*empty*",
    "previousValue": "Previous value",
    "noSelected": "Not selected"
  },
  "guaranteePreviousValueTooltip": {
    "empty": "*empty*",
    "previousValue": "Annex value"
  }
}
